import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1280.000000 938.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,938.000000) scale(0.100000,-0.100000)" >


<path d="M6200 8033 c-73 -6 -198 -33 -300 -65 -104 -33 -421 -190 -960 -478
-80 -43 -345 -177 -590 -299 -432 -216 -447 -225 -530 -299 -382 -345 -549
-698 -511 -1082 6 -58 15 -323 21 -590 31 -1345 25 -1214 55 -1325 84 -318
185 -489 413 -698 139 -127 225 -188 397 -277 264 -137 370 -193 460 -240 50
-26 162 -85 250 -130 88 -45 201 -104 250 -130 50 -26 158 -82 240 -125 83
-43 195 -101 250 -130 171 -91 383 -160 580 -190 208 -31 377 -11 660 77 101
32 362 160 800 393 44 23 152 80 240 125 151 78 214 111 503 261 289 151 332
176 417 239 120 90 309 278 366 365 96 145 168 323 207 510 19 92 22 164 37
920 8 451 20 862 27 914 15 128 4 283 -27 400 -53 196 -189 420 -361 597 -180
183 -170 177 -744 464 -289 144 -529 265 -535 270 -5 4 -77 42 -160 85 -82 43
-199 104 -260 135 -375 196 -449 228 -613 270 -136 34 -386 48 -582 33z m610
-518 c543 -74 989 -238 1400 -516 169 -114 269 -197 420 -349 365 -364 582
-768 682 -1270 20 -102 23 -144 22 -375 0 -277 -6 -334 -60 -550 -183 -731
-758 -1372 -1539 -1715 -293 -128 -567 -203 -940 -257 -172 -24 -638 -24 -820
1 -777 106 -1421 420 -1895 924 -249 264 -468 634 -553 932 -73 256 -88 350
-94 608 -6 245 7 370 62 594 44 175 90 299 177 470 427 844 1353 1424 2423
1518 146 13 579 4 715 -15z"/>
<path d="M6493 7308 c-11 -14 -12 -57 -1 -73 4 -6 3 -17 -3 -25 -18 -30 -10
-40 36 -40 46 0 54 7 33 29 -11 10 -10 15 5 25 23 18 22 23 -13 41 -17 9 -28
21 -24 26 4 7 10 7 17 0 16 -16 47 -14 47 3 0 25 -80 36 -97 14z"/>
<path d="M6690 7252 c0 -43 -5 -63 -17 -73 -14 -12 -12 -15 23 -21 128 -23
195 7 179 81 -8 36 -47 57 -122 65 l-63 7 0 -59z m108 16 c27 -27 6 -98 -28
-98 -17 0 -20 7 -20 39 0 66 18 89 48 59z"/>
<path d="M6332 7264 c-26 -18 -29 -56 -6 -78 35 -35 134 -3 134 44 0 25 -37
50 -75 50 -17 0 -41 -7 -53 -16z m62 -20 c10 -26 7 -44 -8 -44 -8 0 -17 9 -21
20 -11 34 16 57 29 24z"/>
<path d="M6101 7244 c-16 -20 -18 -30 -10 -46 15 -28 55 -43 86 -32 39 13 42
35 5 28 -17 -4 -32 -1 -36 5 -4 6 -2 12 3 12 6 1 16 3 21 4 6 1 19 3 30 4 26
1 26 27 1 41 -36 19 -78 12 -100 -16z m69 -4 c0 -5 -7 -10 -15 -10 -8 0 -15 5
-15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z"/>
<path d="M5987 7249 c-9 -5 -21 -8 -26 -5 -5 3 -23 1 -41 -5 -22 -8 -28 -15
-21 -22 6 -6 11 -26 11 -45 0 -32 2 -33 33 -30 31 3 32 5 29 41 -3 28 0 37 12
37 15 0 21 -23 17 -57 -1 -8 9 -13 26 -13 34 0 60 14 44 24 -6 4 -11 18 -11
31 0 25 -24 55 -43 55 -7 0 -20 -5 -30 -11z"/>
<path d="M5588 7223 c-56 -15 -79 -36 -59 -56 7 -7 17 -2 30 14 33 41 43 12
16 -51 -13 -30 -21 -58 -19 -61 2 -4 23 -2 46 3 119 28 118 28 118 53 0 30
-20 33 -38 5 -12 -20 -42 -28 -42 -10 0 5 9 32 20 60 11 28 20 53 20 55 0 8
-32 4 -92 -12z"/>
<path d="M5770 7217 c-34 -17 -49 -62 -27 -84 34 -34 122 -11 134 36 12 47
-52 76 -107 48z m50 -37 c11 -20 6 -40 -9 -40 -7 0 -31 43 -31 55 0 14 31 2
40 -15z"/>
<path d="M6923 7223 c-26 -10 -12 -24 17 -18 23 5 30 3 30 -9 0 -12 -10 -16
-35 -16 -23 0 -38 -6 -42 -16 -9 -25 18 -42 76 -46 l53 -3 2 45 c1 38 -3 46
-24 57 -26 13 -55 15 -77 6z m37 -73 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10
0 6 5 10 10 10 6 0 10 -4 10 -10z"/>
<path d="M7085 7213 c-17 -3 -20 -12 -20 -55 0 -60 25 -85 72 -73 28 7 28 7 7
21 -27 19 -22 68 6 59 10 -3 21 -1 24 4 4 5 -3 12 -14 16 -11 3 -20 13 -20 21
0 14 -14 16 -55 7z"/>
<path d="M7197 7154 c-14 -14 5 -23 35 -17 23 5 30 3 26 -8 -2 -7 -20 -14 -41
-15 -21 0 -40 -4 -44 -8 -13 -13 14 -41 43 -44 16 -2 33 -8 39 -13 5 -5 18 -9
30 -9 17 0 20 7 22 49 2 43 -1 49 -23 60 -27 12 -77 15 -87 5z m53 -62 c0 -13
-12 -22 -22 -16 -10 6 -1 24 13 24 5 0 9 -4 9 -8z"/>
<path d="M5357 7122 c-30 -31 -33 -42 -14 -42 7 0 18 -13 24 -30 14 -38 39
-47 71 -27 34 20 42 42 13 32 -27 -8 -48 33 -25 51 19 15 18 35 -1 28 -8 -4
-21 -1 -28 5 -10 8 -20 4 -40 -17z"/>
<path d="M7443 7115 c-30 -21 -29 -28 7 -68 34 -39 36 -47 16 -47 -8 0 -26 15
-40 33 l-26 32 0 -26 c0 -31 22 -52 73 -69 32 -10 42 -9 62 4 33 22 32 33 -12
78 -33 34 -35 38 -15 38 12 0 26 -9 32 -20 13 -25 43 -27 38 -3 -7 39 -101 72
-135 48z"/>
<path d="M5265 7073 c-53 -13 -63 -60 -15 -69 17 -4 30 -11 30 -15 0 -5 -12
-6 -26 -3 -20 5 -25 3 -22 -7 7 -20 31 -22 72 -5 56 23 46 66 -15 66 -10 0
-19 5 -19 11 0 5 8 9 18 7 11 -2 20 2 21 7 2 12 -16 15 -44 8z"/>
<path d="M5140 7023 c-26 -10 -60 -46 -60 -64 0 -31 30 -52 68 -46 39 7 62 23
62 44 0 12 -3 13 -14 3 -8 -6 -25 -10 -38 -7 -21 4 -21 5 10 18 29 12 47 49
23 49 -5 0 -15 2 -23 4 -7 3 -20 2 -28 -1z m10 -33 c0 -5 -7 -10 -15 -10 -8 0
-15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z"/>
<path d="M7586 6985 c-8 -51 3 -75 36 -75 11 0 26 -7 34 -15 17 -16 69 -21 59
-5 -3 5 1 26 10 46 8 20 14 39 12 40 -2 2 -18 7 -37 10 -24 5 -31 4 -26 -5 11
-17 -23 -66 -36 -53 -7 7 -6 22 3 46 15 40 14 42 -22 51 -25 6 -27 4 -33 -40z"/>
<path d="M4965 6954 c-15 -23 -21 -54 -8 -41 3 4 17 -9 30 -28 27 -40 40 -43
77 -14 33 26 34 41 2 33 -19 -4 -26 -1 -31 16 -4 12 -2 27 4 33 18 18 13 23
-24 24 -25 1 -38 -5 -50 -23z"/>
<path d="M7780 6958 c0 -13 -9 -38 -20 -56 l-21 -33 32 -30 c49 -46 129 -34
129 20 0 20 -30 51 -49 51 -9 0 -11 8 -7 25 5 18 1 27 -13 35 -32 17 -51 12
-51 -12z m60 -87 c0 -20 -27 -48 -36 -38 -4 3 -4 18 0 32 7 29 36 34 36 6z"/>
<path d="M4853 6874 c-18 -14 -33 -32 -33 -40 0 -21 21 -17 27 6 3 11 12 20
19 20 21 0 17 -23 -6 -38 -24 -15 -26 -50 -4 -59 8 -3 27 3 42 14 15 11 35 22
45 26 30 11 29 32 -2 65 -35 39 -46 39 -88 6z m48 -67 c-13 -13 -26 -3 -16 12
3 6 11 8 17 5 6 -4 6 -10 -1 -17z"/>
<path d="M7995 6840 c-10 -16 6 -32 26 -27 29 8 31 -7 7 -39 -27 -35 -39 -44
-50 -38 -4 3 -8 -1 -8 -8 0 -15 59 -58 79 -58 7 0 11 6 8 14 -6 15 38 86 53
86 6 0 10 -8 10 -18 0 -24 8 -32 26 -25 8 3 14 15 14 27 -1 15 -19 32 -61 59
-60 37 -92 46 -104 27z"/>
<path d="M4741 6806 c-77 -43 -39 -141 39 -101 39 20 56 43 42 57 -8 8 -13 7
-18 -5 -4 -10 -17 -17 -33 -17 -23 1 -24 2 -9 13 9 7 25 17 35 23 15 10 16 13
4 28 -16 19 -28 20 -60 2z m19 -24 c0 -13 -12 -22 -22 -16 -10 6 -1 24 13 24
5 0 9 -4 9 -8z"/>
<path d="M4643 6743 c-7 -3 -13 -11 -13 -19 0 -8 -8 -14 -19 -14 -10 0 -26
-11 -35 -25 -20 -30 -20 -35 -1 -35 9 0 21 -12 27 -27 7 -16 13 -30 14 -32 5
-6 64 40 64 50 0 5 -7 9 -15 9 -26 0 -30 30 -6 46 34 24 21 60 -16 47z"/>
<path d="M8115 6676 c-13 -19 -14 -29 -6 -45 15 -27 51 -51 76 -51 17 0 16 3
-10 24 -37 30 -27 44 14 20 39 -23 60 -9 40 27 -28 54 -87 66 -114 25z m85
-16 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10 9 10 9 0 16 -4 16 -10z"/>
<path d="M4463 6656 c-4 -7 -19 -19 -31 -25 -23 -12 -52 -65 -52 -96 0 -27 38
-55 75 -55 24 0 45 9 70 31 30 27 35 37 35 75 0 24 -4 44 -8 44 -4 0 -23 -16
-42 -35 -32 -33 -33 -35 -11 -35 28 0 23 -24 -7 -28 -31 -5 -62 16 -62 41 0
29 18 47 47 47 27 0 42 28 22 41 -19 12 -27 11 -36 -5z"/>
<path d="M8232 6588 c-7 -7 -12 -20 -12 -29 0 -25 48 -79 71 -79 23 0 25 16 3
28 -9 5 -14 18 -12 32 4 29 28 39 28 12 0 -23 25 -46 40 -37 15 10 12 21 -16
54 -28 33 -78 43 -102 19z"/>
<path d="M8400 6537 c0 -17 -62 -77 -80 -77 -8 0 -3 -11 15 -30 l28 -29 19 24
c20 26 48 33 48 13 0 -6 -10 -22 -22 -35 l-22 -23 22 -22 c12 -12 23 -20 24
-17 2 2 16 19 32 36 28 31 28 33 12 58 -9 14 -23 25 -31 25 -19 0 -19 14 0 30
22 18 19 28 -15 45 -24 12 -30 13 -30 2z"/>
<path d="M4261 6404 c-12 -15 -21 -33 -21 -41 0 -65 84 -74 115 -12 23 43 18
55 -10 25 -14 -15 -30 -24 -36 -20 -7 4 -1 16 15 33 29 31 26 41 -15 41 -18 0
-35 -9 -48 -26z m39 -14 c0 -5 -7 -10 -16 -10 -8 0 -12 5 -9 10 3 6 10 10 16
10 5 0 9 -4 9 -10z"/>
<path d="M8505 6360 c-3 -11 -10 -20 -14 -20 -4 0 -16 -6 -26 -14 -19 -14 -19
-15 -1 -35 24 -26 31 -26 56 -1 25 25 40 25 40 0 0 -10 -10 -25 -22 -31 -33
-17 -33 -17 -8 -44 l23 -24 28 29 c36 35 37 64 4 86 -14 9 -23 20 -20 24 3 5
-8 18 -24 29 -29 21 -30 21 -36 1z"/>
<path d="M6395 6315 c-4 -31 -6 -58 -3 -60 2 -2 79 -7 171 -11 92 -4 167 -10
167 -14 0 -4 -6 -12 -13 -18 -24 -20 -471 -251 -478 -246 -4 2 -7 41 -7 87 1
121 -40 206 -127 264 -51 34 -115 43 -307 43 l-184 0 -17 -112 c-63 -401 -70
-438 -82 -438 -7 0 -19 10 -27 22 l-15 22 -38 -36 c-45 -42 -42 -51 27 -85 30
-14 72 -23 138 -28 185 -12 339 37 670 215 333 179 629 325 727 359 212 73
402 60 491 -32 58 -60 83 -159 62 -249 -17 -73 -73 -191 -118 -252 -55 -74
-60 -85 -18 -46 48 45 124 150 155 214 17 37 25 75 29 134 4 77 3 86 -27 146
-91 185 -227 215 -589 129 -18 -4 -25 -1 -29 15 -2 11 -13 22 -23 25 -9 2
-132 5 -273 6 l-255 2 -7 -56z m-413 -100 c69 -24 104 -69 112 -141 6 -55 -4
-146 -19 -186 -8 -20 -179 -92 -267 -113 -74 -17 -158 -20 -158 -4 0 20 82
453 87 462 9 15 192 1 245 -18z"/>
<path d="M4178 6306 c-10 -7 -18 -21 -18 -30 0 -19 -21 -21 -38 -4 -8 8 -15 8
-27 -2 -18 -15 -20 -50 -2 -50 16 -1 62 -42 70 -64 7 -18 9 -18 32 4 26 24 33
50 14 50 -14 0 -39 25 -39 39 0 20 39 11 55 -11 l16 -23 20 24 c25 31 25 32
-16 59 -40 25 -44 26 -67 8z"/>
<path d="M5338 6246 c-164 -210 -173 -442 -21 -549 119 -84 260 -96 548 -46
88 16 155 44 202 87 44 40 308 170 320 158 4 -4 3 -10 -2 -14 -18 -13 -132
-147 -143 -169 -7 -12 -12 -33 -12 -47 l0 -26 295 0 295 0 0 23 c0 12 3 39 6
60 l7 37 -198 0 c-117 0 -195 4 -193 9 2 5 60 76 129 158 l126 148 109 57
c225 117 408 152 537 103 38 -15 14 13 -25 30 -62 25 -192 31 -259 12 -30 -9
-263 -122 -519 -250 -256 -129 -507 -251 -558 -271 -254 -101 -442 -112 -597
-35 -79 40 -135 135 -135 230 0 86 45 209 112 307 41 59 26 52 -24 -12z"/>
<path d="M8600 6200 c-23 -23 -24 -33 -9 -63 29 -57 100 -77 120 -33 14 31
-10 80 -51 101 -37 19 -36 19 -60 -5z m60 -65 c-7 -8 -16 -15 -21 -15 -15 0
-10 28 9 46 16 17 17 17 20 0 2 -9 -2 -23 -8 -31z"/>
<path d="M3998 6141 c-41 -64 -50 -105 -21 -99 10 2 18 11 18 21 0 9 3 17 8
17 4 0 10 0 15 0 14 0 62 -51 57 -61 -4 -5 -2 -9 4 -9 12 0 61 63 61 78 0 7
-9 12 -21 12 -22 0 -79 36 -79 50 0 4 9 10 20 13 28 7 26 37 -2 36 -17 0 -34
-16 -60 -58z"/>
<path d="M8764 6092 c-5 -18 -56 -52 -80 -52 -19 0 -17 -20 5 -49 l18 -23 27
25 c14 14 40 30 56 37 35 15 37 28 10 58 -25 27 -31 27 -36 4z"/>
<path d="M8738 5955 c-21 -46 26 -115 79 -115 50 0 54 82 6 120 -36 28 -71 26
-85 -5z m82 -28 c0 -8 -9 -22 -19 -31 -26 -23 -39 -2 -15 25 20 22 34 25 34 6z"/>
<path d="M8845 5821 c-3 -6 -15 -11 -26 -11 -10 0 -19 -4 -19 -10 0 -5 -7 -7
-15 -4 -12 5 -15 -2 -15 -29 0 -58 72 -124 95 -87 3 5 -4 27 -15 50 -24 47
-13 53 18 10 16 -22 31 -30 52 -30 17 0 30 1 30 3 0 2 -12 27 -28 57 -27 54
-61 76 -77 51z m59 -40 c7 -10 -22 -37 -30 -28 -9 8 3 37 15 37 5 0 12 -4 15
-9z m-89 -69 c-9 -9 -25 19 -24 43 0 16 2 15 15 -8 9 -16 13 -32 9 -35z"/>
<path d="M8929 5668 c-17 -35 -51 -68 -67 -68 -12 0 -12 3 -2 15 14 16 6 35
-16 35 -20 0 -18 -46 5 -69 10 -10 41 -21 72 -25 29 -4 60 -12 67 -19 11 -9
13 -6 10 13 -2 19 -9 25 -27 25 -22 0 -45 25 -24 25 4 0 14 4 21 9 11 7 11 15
-2 45 -18 42 -21 44 -37 14z"/>
<path d="M5885 5364 c-45 -23 -47 -26 -60 -117 -10 -68 -27 -117 -84 -243 -78
-173 -91 -193 -139 -218 -37 -19 -44 -59 -13 -76 27 -14 194 -13 225 2 14 6
29 20 32 31 6 20 1 27 -42 53 -16 9 -17 15 -7 37 12 26 15 27 102 27 49 0 101
-4 115 -10 35 -13 35 -53 1 -68 -28 -13 -33 -43 -10 -62 41 -34 316 -30 356 6
29 27 24 52 -16 68 -29 12 -40 27 -67 88 -57 129 -154 321 -190 378 -40 62
-59 80 -105 104 -40 20 -60 20 -98 0z m76 -304 c44 -73 41 -80 -41 -80 -38 0
-70 4 -70 9 0 5 10 35 22 66 26 70 49 71 89 5z"/>
<path d="M6880 5369 c-19 -5 -125 -9 -235 -8 -110 1 -206 1 -212 0 -20 -2 -72
-80 -84 -124 -13 -50 -5 -82 25 -103 22 -14 28 -14 53 -1 15 8 43 33 61 56 44
55 69 54 77 -3 8 -54 -10 -359 -22 -363 -32 -11 -73 -46 -73 -62 0 -31 43 -50
137 -60 93 -11 199 -2 246 19 41 20 37 61 -8 86 -20 10 -38 28 -41 39 -2 11
-3 101 -2 200 3 176 4 180 25 183 14 2 27 -6 40 -24 39 -56 61 -74 96 -74 20
0 41 7 50 18 38 41 9 154 -52 205 -18 15 -36 27 -39 26 -4 -1 -23 -5 -42 -10z"/>
<path d="M7305 5366 c-46 -20 -56 -39 -66 -120 -6 -60 -21 -105 -78 -231 -83
-187 -90 -198 -141 -230 -45 -29 -48 -37 -20 -65 17 -17 33 -20 119 -20 90 0
103 2 127 23 l27 24 -21 19 c-11 10 -28 25 -37 32 -14 12 -14 17 -2 35 12 19
26 22 93 25 97 4 154 -10 154 -39 0 -11 -11 -24 -25 -31 -18 -8 -25 -19 -25
-38 0 -41 38 -52 184 -52 101 -1 131 3 162 18 48 23 51 51 9 73 -30 17 -48 49
-175 311 -75 155 -133 238 -182 260 -50 23 -63 24 -103 6z m74 -310 c17 -29
31 -59 31 -65 0 -7 -25 -11 -71 -11 l-71 0 6 31 c10 52 37 99 56 99 12 0 30
-20 49 -54z"/>
<path d="M4880 5359 c-51 -21 -53 -52 -4 -81 l36 -21 -4 -211 c-4 -225 -9
-249 -53 -260 -18 -5 -25 -13 -25 -31 0 -48 24 -53 280 -51 l235 1 57 28 c69
34 131 101 153 165 66 192 -14 401 -173 453 -48 16 -467 23 -502 8z m378 -116
c53 -40 67 -86 67 -223 0 -141 -12 -177 -67 -206 -38 -20 -94 -22 -111 -6 -17
18 -23 412 -7 443 10 18 18 21 53 16 22 -3 52 -14 65 -24z"/>
<path d="M7305 4429 c-22 -4 -134 -8 -248 -8 -123 -1 -216 -5 -228 -11 -30
-16 -24 -57 10 -74 16 -9 31 -26 35 -38 12 -40 19 -261 11 -343 -7 -73 -10
-82 -41 -112 -40 -37 -43 -60 -10 -73 38 -14 553 -15 570 -1 22 18 57 108 59
151 1 42 -16 70 -43 70 -20 0 -41 -22 -63 -66 -23 -45 -71 -64 -161 -64 -91 0
-96 6 -96 108 0 81 13 99 57 85 21 -7 31 -20 41 -51 11 -33 19 -42 36 -42 37
0 51 41 51 151 0 89 -2 101 -23 121 -30 30 -54 15 -65 -41 l-8 -42 -47 3 -47
3 -3 71 c-4 99 6 108 110 102 77 -5 80 -6 121 -46 57 -56 83 -54 101 5 14 45
-38 157 -71 152 -4 -1 -26 -5 -48 -10z"/>
<path d="M3901 4406 c-30 -34 -61 -103 -61 -138 0 -42 25 -78 53 -78 30 0 39
8 70 62 30 51 50 61 113 56 25 -2 40 -8 42 -19 1 -8 -24 -60 -56 -115 -229
-385 -226 -380 -199 -402 9 -8 105 -12 288 -12 l274 -1 27 30 c68 76 61 211
-11 211 -23 0 -34 -9 -59 -50 -36 -58 -65 -72 -136 -68 -39 2 -52 7 -54 21 -2
9 49 108 114 220 146 252 144 249 144 268 0 39 -20 41 -232 31 -112 -6 -224
-7 -250 -3 -41 7 -50 5 -67 -13z"/>
<path d="M4795 4421 c-95 -25 -187 -97 -225 -176 -84 -174 -17 -371 154 -455
162 -80 376 -26 474 120 108 159 39 394 -143 488 -41 21 -66 26 -140 28 -49 2
-103 -1 -120 -5z m106 -144 c61 -41 109 -166 109 -283 0 -45 -4 -59 -25 -79
-46 -47 -115 -23 -154 53 -10 21 -29 71 -41 112 -29 97 -24 164 14 197 34 29
54 29 97 0z"/>
<path d="M5334 4416 c-28 -13 -44 -33 -44 -57 0 -5 15 -19 34 -30 22 -13 39
-33 45 -52 15 -51 22 -215 12 -305 -8 -76 -12 -87 -40 -112 -37 -34 -38 -44
-8 -74 55 -55 238 -39 254 22 5 20 0 30 -28 53 -31 25 -33 32 -37 97 -4 75 8
112 36 112 9 0 92 -67 184 -149 177 -158 198 -174 221 -165 29 11 36 61 39
289 3 145 8 238 15 250 6 12 23 27 37 35 18 9 26 22 26 40 0 46 -22 55 -135
55 -109 0 -135 -9 -135 -49 0 -11 14 -32 31 -47 24 -20 32 -35 36 -71 7 -62
-3 -98 -26 -98 -10 0 -53 30 -96 68 -42 37 -113 97 -157 135 l-79 67 -77 0
c-42 -1 -91 -7 -108 -14z"/>
<path d="M6172 4406 c-31 -24 -72 -111 -72 -151 1 -89 89 -92 147 -4 19 28 32
39 47 37 29 -4 34 -40 26 -225 -5 -138 -9 -165 -24 -182 -11 -12 -27 -21 -37
-21 -23 0 -36 -44 -19 -65 42 -50 328 -57 381 -9 30 27 23 51 -21 79 l-40 26
2 197 c3 194 3 197 25 200 15 2 27 -5 39 -25 36 -58 56 -73 96 -73 51 0 73 32
65 95 -6 44 -44 116 -68 131 -7 4 -127 8 -268 8 -237 1 -256 0 -279 -18z"/>
<path d="M7743 4411 c-109 -37 -200 -128 -229 -228 -60 -208 92 -411 322 -430
52 -5 77 0 155 27 127 43 165 82 157 161 -2 27 -8 35 -26 37 -13 2 -31 -3 -41
-12 -22 -20 -96 -46 -130 -46 -91 0 -168 62 -195 158 -21 75 -20 118 2 162 46
93 173 75 242 -35 20 -31 46 -58 61 -64 36 -12 86 11 100 46 16 41 3 120 -25
164 -23 34 -30 38 -78 42 -29 2 -71 11 -93 20 -54 22 -158 21 -222 -2z"/>
<path d="M8311 4420 c-90 -19 -120 -69 -62 -103 28 -16 29 -19 36 -127 7 -110
-1 -289 -14 -306 -3 -5 -18 -17 -33 -27 -86 -55 32 -116 194 -101 115 11 162
61 102 109 -22 17 -27 31 -31 85 -2 36 0 72 6 80 7 10 33 16 85 18 92 5 101
-5 90 -100 -6 -51 -12 -67 -37 -89 -38 -35 -32 -70 15 -90 46 -20 211 -17 261
4 31 13 37 21 37 46 0 21 -6 32 -19 36 -37 11 -44 66 -38 260 l6 180 31 25
c38 31 39 64 3 87 -22 15 -49 18 -144 18 -104 0 -121 -2 -146 -21 -39 -29 -40
-55 -4 -82 24 -18 31 -31 36 -77 10 -74 0 -85 -80 -85 -93 0 -95 2 -95 76 0
59 2 65 30 86 38 27 39 61 4 85 -31 20 -164 27 -233 13z"/>
<path d="M4908 3304 c4 -97 14 -109 61 -75 16 12 32 21 35 21 3 0 6 -20 6 -44
0 -57 19 -64 73 -30 23 14 54 33 69 42 34 21 35 26 3 40 -32 15 -38 15 -30 2
8 -13 -13 -40 -31 -40 -17 0 -19 41 -3 57 7 7 1 17 -24 32 -42 26 -57 27 -57
2 0 -21 -23 -45 -33 -34 -11 10 -8 48 4 60 7 7 1 17 -24 32 -19 11 -38 21 -43
21 -5 0 -8 -38 -6 -86z"/>
<path d="M7844 3336 c-15 -12 -17 -17 -6 -27 6 -7 12 -17 12 -21 0 -14 -32 -9
-44 7 -10 13 -15 12 -43 -6 -18 -12 -33 -24 -33 -27 1 -4 24 -18 53 -32 28
-14 53 -31 55 -39 3 -10 0 -12 -13 -7 -19 7 -48 -11 -39 -25 10 -16 40 -9 61
14 17 17 22 38 25 100 2 42 0 77 -3 77 -3 0 -14 -6 -25 -14z"/>
<path d="M7654 3279 c-16 -13 -31 -24 -34 -27 -3 -2 5 -11 16 -20 26 -21 44
-54 44 -81 0 -25 0 -25 45 -4 34 16 46 33 24 33 -5 0 -23 27 -38 60 l-27 61
-30 -22z"/>
<path d="M7526 3188 c-21 -27 -23 -34 -10 -38 8 -3 23 -20 34 -38 23 -37 33
-39 78 -12 38 24 43 43 7 34 -20 -5 -27 -1 -34 17 -7 19 -5 28 12 42 l22 19
-27 -6 c-15 -3 -30 -2 -33 4 -10 17 -22 11 -49 -22z"/>
<path d="M5148 3179 c-18 -10 -23 -35 -12 -64 8 -20 56 -45 89 -45 34 0 32 16
-4 23 -16 3 -31 13 -35 23 -6 17 -7 17 62 -2 18 -5 22 -2 22 14 0 44 -78 77
-122 51z m80 -28 c3 -8 -1 -12 -9 -9 -7 2 -15 10 -17 17 -3 8 1 12 9 9 7 -2
15 -10 17 -17z"/>
<path d="M5393 3146 c8 -20 -19 -97 -39 -113 -18 -14 -13 -18 62 -43 104 -36
164 -17 164 50 0 39 -25 63 -91 88 -95 35 -103 36 -96 18z m116 -58 c18 -50
-27 -112 -62 -85 -16 11 -16 15 -1 60 18 52 48 65 63 25z"/>
<path d="M7420 3126 c-7 -9 -23 -16 -35 -16 -13 0 -33 -8 -45 -18 -20 -16 -21
-19 -6 -31 9 -7 16 -26 16 -42 0 -34 0 -34 46 -14 34 14 35 15 18 40 -18 27
-13 55 10 55 15 0 26 -21 26 -51 0 -10 5 -19 10 -19 20 0 73 32 64 39 -5 3
-17 20 -26 36 -19 34 -58 44 -78 21z"/>
<path d="M7215 3060 c-24 -9 -50 -38 -42 -46 3 -3 15 4 27 16 17 17 25 19 34
10 8 -9 7 -15 -8 -24 -10 -6 -28 -19 -40 -28 -20 -18 -21 -18 -2 -33 16 -12
23 -12 54 0 19 8 42 15 51 15 32 0 40 20 22 53 -9 18 -20 35 -26 39 -13 10
-44 9 -70 -2z m35 -70 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10
6 0 10 -4 10 -10z"/>
<path d="M7038 3025 c-31 -27 -34 -35 -14 -35 7 0 17 -14 22 -31 13 -47 35
-57 78 -36 38 18 50 43 16 32 -15 -5 -22 0 -30 21 -10 26 -1 43 23 44 4 0 7 5
7 10 0 6 -11 8 -25 4 -15 -4 -25 -2 -25 5 0 18 -23 12 -52 -14z"/>
<path d="M5767 3001 c3 -25 0 -50 -10 -69 -17 -35 -9 -42 41 -42 21 0 27 5 28
23 0 12 4 46 9 75 l8 52 -41 0 -40 0 5 -39z"/>
<path d="M5608 3019 c-26 -15 -23 -64 4 -83 25 -18 93 -21 103 -6 4 6 -6 10
-23 10 -16 0 -36 7 -43 17 -13 15 -10 15 34 9 43 -7 47 -5 47 13 0 41 -78 66
-122 40z m77 -19 c3 -5 -3 -10 -14 -10 -12 0 -21 5 -21 10 0 6 6 10 14 10 8 0
18 -4 21 -10z"/>
<path d="M5870 3011 c0 -11 38 -21 56 -14 26 10 14 23 -21 23 -19 0 -35 -4
-35 -9z"/>
<path d="M6588 2993 c-38 -4 -48 -15 -27 -29 7 -4 10 -29 7 -65 l-4 -59 42 0
c42 0 64 13 44 25 -15 9 -13 115 3 115 8 0 7 4 -3 10 -8 5 -17 9 -20 8 -3 -1
-22 -3 -42 -5z"/>
<path d="M6931 2990 c-57 -14 -64 -56 -10 -67 16 -3 29 -10 29 -15 0 -6 -13
-8 -31 -4 -22 4 -29 2 -27 -7 6 -17 42 -20 84 -7 46 16 45 50 -3 62 -43 11
-44 32 -2 23 24 -6 30 -4 27 6 -6 17 -23 20 -67 9z"/>
<path d="M5869 2973 c-1 -5 0 -21 1 -37 1 -16 -4 -33 -12 -37 -19 -13 8 -29
47 -29 29 0 30 1 32 55 l2 55 -35 0 c-19 0 -34 -3 -35 -7z"/>
<path d="M5971 2964 c16 -38 64 -114 72 -114 6 0 32 23 58 50 l48 50 -28 0
c-21 0 -30 -6 -34 -21 -7 -27 -33 -19 -30 10 2 17 -3 21 -26 21 -16 0 -37 3
-47 7 -9 3 -15 2 -13 -3z"/>
<path d="M6775 2960 c-4 -6 -14 -9 -23 -5 -24 9 -86 -15 -73 -28 6 -6 11 -26
11 -45 0 -32 2 -33 33 -30 30 3 32 5 29 41 -2 27 1 39 14 44 22 8 36 -16 29
-51 -5 -28 -4 -28 31 -23 20 3 38 8 40 10 2 2 -2 23 -9 48 -11 39 -17 44 -44
47 -17 2 -34 -2 -38 -8z"/>
<path d="M6183 2935 c-25 -10 -33 -20 -33 -39 0 -48 62 -78 116 -54 l29 12
-37 4 c-20 2 -42 10 -48 18 -11 12 -5 14 39 14 54 0 62 7 34 33 -27 24 -64 28
-100 12z m58 -20 c-1 -15 -24 -12 -29 3 -3 9 2 13 12 10 10 -1 17 -7 17 -13z"/>
<path d="M6323 2933 c-10 -3 -10 -10 -2 -25 8 -15 8 -27 0 -45 -15 -34 -16
-33 39 -33 28 0 50 5 50 10 0 6 -4 10 -10 10 -5 0 -10 12 -10 26 0 22 3 25 23
21 28 -8 52 6 44 26 -4 10 -22 14 -64 14 -32 1 -64 -1 -70 -4z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
